var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsObject, IsUUID } from 'class-validator';
export class PreventionEvaluationResponseFullSizeDto {
    id;
    createdAt;
    updatedAt;
    preventionEvaluationAnswer;
    preventionEvaluationAnswerId;
    preventionEvaluationQuestion;
    preventionEvaluationQuestionId;
    preventionEvaluationResponseSet;
    preventionEvaluationResponseSetId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationResponseFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionEvaluationResponseFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionEvaluationResponseFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationAnswer", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationAnswerId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationQuestion", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationQuestionId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationResponseSet", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationResponseFullSizeDto.prototype, "preventionEvaluationResponseSetId", void 0);
//# sourceMappingURL=prevention-evaluation-response.full-size.dto.js.map